































































































import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from './Icon.vue'
import { EUserPermissions } from '@zunta/configurations'
import { User } from '@/classes/User'
import { ROUTING_NUMBER_IMAGE_MAP } from '@/constants'
import Api from '@/api'
import { VPopover } from 'v-tooltip'
import Status from '@/components/statuses/Status.vue'

@Component({
  props: {
    paymentMethod: {
      type: Object,
      required: true
    },
    viewOnly: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    showPrimary: {
      type: Boolean,
      default: true
    },
    showEdit: {
      type: Boolean,
      default: true
    },
    showDelete: {
      type: Boolean,
      default: true
    }
  },
  components: {
    Status,
    Icon,
    VPopover
  }
})
export default class eCheckCard extends Vue {
  EUserPermissions: any = EUserPermissions
  user: User = Api.getUser() as User
  popoverOpen: boolean = false

  get routingBankImage () {
    return ROUTING_NUMBER_IMAGE_MAP[this.$props.paymentMethod.echeckRouting]
  }
}
